import { badgeClassName } from "../../elements/badgeClassName";

// Mirrors legacy StatusBadge's color mapping for CommunicationActivityStatus.
const STATUS_LABELS: Record<number, string> = {
  0: "Open",
  1: "Completed",
  2: "Cancelled",
  3: "Scheduled",
};

const STATUS_VARIANTS: Record<string, string> = {
  Completed: "success",
  Cancelled: "danger",
  Scheduled: "warning",
};

export function CommunicationActivityStatusBadge({ value }: { value: unknown }) {
  const label = STATUS_LABELS[value as number];

  if (!label) {
    return null;
  }

  const variant = STATUS_VARIANTS[label] ?? "info";

  return <span className={badgeClassName(variant)}>{label}</span>;
}
